import { render } from "./SummaryLayout.vue?vue&type=template&id=5c516b22&scoped=true"
import script from "./SummaryLayout.vue?vue&type=script&lang=js"
export * from "./SummaryLayout.vue?vue&type=script&lang=js"

import "./SummaryLayout.vue?vue&type=style&index=0&id=5c516b22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c516b22"]])

export default __exports__